import { css } from "@/styles/stitches.config";
import { PropsWithChildren } from "react";
import { PcHeader } from "./pc-header/pc-header";
import { PcFooter } from "./pc-footer/pc-footer";
import { isMobile } from "react-device-detect";
import BottomBar from "@/components/bottomBar";

export function Layout({ children }: PropsWithChildren) {
  return (
    <div className={css({})()}>
    {!isMobile && (
      <PcHeader />
    )}
      {children}
      {!isMobile && (
        <PcFooter />
      )}
      {isMobile && (
        <BottomBar index={1} />
      )}
    </div>
  );
}
